import {css} from 'lit';
export const styles = css`:host {
  --trigger-color: var(--dark-text);
  --trigger-font-size: 18px;
  --trigger-font-weight: 400;
  --trigger-padding: 4px;
  --content-border: none;
  --content-border-radius: 2px;
  --content-body-shadow: none;
  --header-padding: 8px;
  --header-font-size: 1.3em;
  --header-font-weight: 400;
  --header-background: transparent;
  --header-border-bottom: none;
  --header-color: inherit;
  --body-max-height: 300px;
  --body-padding: 8px;
  --body-font-size: 1em;
  --body-font-weight: 400;
  --body-background: var(--sl-tooltip-background-color);
  --body-color: inherit;

  font-size: var(--font-size-sm);
}

.trigger {
  --link-focus-outline-offset: 0;

  padding: var(--trigger-padding);
  border: none;
  background-color: transparent;
  color: var(--trigger-color);
  font-size: var(--trigger-font-size);
  font-weight: var(--trigger-font-weight);
  line-height: 1;
}

slot[name='header']:not([hidden]),
slot[name='body']:not([hidden]) {
  display: block;
}

slot[name='header'] {
  padding: var(--header-padding);
  background-color: var(--header-background);
  border-bottom: var(--header-border-bottom);
  border-radius: var(--content-border-radius) var(--content-border-radius) 0 0;
  color: var(--header-color);
  font-size: var(--header-font-size);
  font-weight: var(--header-font-weight);
}

slot[name='body'] {
  max-height: var(--body-max-height);
  padding: var(--body-padding);
  color: var(--body-color);
  font-size: var(--body-font-size);
  font-weight: var(--body-font-weight);
  overflow: auto;
  pointer-events: all;
}

sl-tooltip {
  --max-width: 250px;
  --sl-tooltip-padding: 0;
  --sl-tooltip-background-color: var(--body-background);
  --sl-tooltip-border-radius: var(--content-border-radius);
}

sl-tooltip::part(body) {
    margin: 8px 8px 0;
    border: var(--content-border);
    box-shadow: var(--content-shadow);
  }

sl-tooltip::part(base__arrow) {
    z-index: 1;
    border-right: var(--content-border);
    border-bottom: var(--content-border);
  }
`;
export default styles;
